import type { SortingRule } from 'react-table';
import * as cx from 'classnames';
import ColumnSortIndicator from './ColumnSortIndicator';

type TableHeaderProps = {
  title: string;
  /**
   * If true, the header will be centered.
   */
  center?: boolean;
  sort?: {
    // id is the identifier of the column for which the sort indicator is being rendered.
    id: string;
    // currentMode is the sort mode that's currently active for the table.
    currentMode: SortingRule;
  };
};

/**
 * A minimal wrapper for a SimpleReactTable column header.
 */
const TableHeader = ({ title, sort, center = false }: TableHeaderProps) => (
  <div
    className={cx('table-header', {
      'table-header--center': center,
    })}
  >
    {title}
    {!!sort && <ColumnSortIndicator column={sort.id} currentSortMode={sort.currentMode} />}
  </div>
);

export default TableHeader;
